import React from 'react';
import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import {
  StatusBarWrapper,
  BoxWrapper,
  DueMonthlyWrapper,
  LabelDueMonthly,
  PricingBlockMain,
  BeforeTaxesLabel,
  DueNowWrapper,
  IntegralPart
} from './css';
import { formatCurrency } from '../../utils/currencyFormatter';

const getFormattedPricing = price => {
  return <IntegralPart>{formatCurrency(price)}</IntegralPart>;
};

const FmSOWStatusBar = ({
  step,
  isLastStep,
  isFormTouched,
  onSaveAndExit,
  onProceedClick,
  onBackClick,
  totalMonthly,
  totalOneTime,
  onQuoteDownload
}) => {
  const localizedStrings = useLocalizedStringsContext();
  isFormTouched = true;
  const {
    formButtons: {
      continueButtonLabel,
      backLabel,
      saveContinueLaterButtonLabel,
      submitButtonLabel
    }
  } = localizedStrings;

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <BoxWrapper>
          <>
            <DueMonthlyWrapper>
              <div>
                <LabelDueMonthly>Due Monthly</LabelDueMonthly>
                <PricingBlockMain>
                  {getFormattedPricing(totalMonthly)}
                </PricingBlockMain>
                <BeforeTaxesLabel>Before Taxes</BeforeTaxesLabel>
              </div>
            </DueMonthlyWrapper>
            <DueNowWrapper>
              <>
                <div>
                  <LabelDueMonthly>Due Now</LabelDueMonthly>
                  <PricingBlockMain>
                    {getFormattedPricing(totalOneTime)}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>Before Taxes</BeforeTaxesLabel>
                </div>
              </>
            </DueNowWrapper>
          </>
          <>
            {step !== 1 && (
              <button
                type="button"
                onClick={onBackClick}
                className="frg-button color-green"
              >
                {backLabel}
              </button>
            )}
            <button
              type="button"
              onClick={e => onSaveAndExit(e)}
              style={{ marginLeft: '1em', height: '60px' }}
              className="frg-button color-purple"
              disabled={!isFormTouched}
            >
              {saveContinueLaterButtonLabel}
            </button>
            {
              isLastStep && <button
                type="button"
                onClick={() => {
                  onQuoteDownload();
                }}
                style={{ marginLeft: '1em', height: '60px', marginTop: '1px' }}
                className='frg-button color-purple'
              >
                Download SOW PDF
              </button>
            }
            <button
              type="button"
              onClick={e => onProceedClick(e)}
              style={{ marginLeft: '1em', height: '60px', marginTop: '1px' }}
              className={`frg-button color-${isLastStep ? 'purple' : 'green'}`}
            >
              {isLastStep ? submitButtonLabel : continueButtonLabel}
            </button>
          </>
        </BoxWrapper>
      </div>
    </StatusBarWrapper>
  );
};

FmSOWStatusBar.propTypes = {
  step: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  totalMonthly: PropTypes.number.isRequired,
  totalOneTime: PropTypes.number.isRequired
};

FmSOWStatusBar.defaultProps = {};

export default FmSOWStatusBar;
